import { PropertiesActionTypes } from './properties.types';

export const setCurrentProperties = properties => ({
    type: PropertiesActionTypes.SET_CURRENT_PROPERTIES,
    payload: properties
})